module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("I am Tasneem. Born and raised in the UAE, now I am a resident of this wonderful country. I am a Certified Human Resources Professional, a Motivation Counsellor, and a community worker.")]), _vm._v(" "), _c('p', [_vm._v("This book will be my first write-up, and I will be writing more books in coming years, and would love to be known as a successful author.")]), _vm._v(" "), _c('p', [_vm._v("In need of your love, support and prayers for me.")]), _vm._v(" "), _c('p', [_vm._v("Thanks")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-256644c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0